import type { PageRouteSettings } from '@Core/lib/tasks/utils/types';

import type { SdkPageHandle, SdkUtils } from './types';

/**
 * The handle `Sdk.page(id)` returns. It exists for any id: the stored source
 * is validated against the workspace's pages at save time, and an unpublished
 * page must still render in the editor preview, so an unknown or unpublished
 * id degrades the same way `Sdk.utils.page.url` does instead of throwing.
 */
export function createPageHandle(
  id: string,
  pageUtils: SdkUtils['page'],
  settings: PageRouteSettings
): SdkPageHandle {
  return {
    id,
    route: settings?.[id]?.route ?? null,
    url: (params) => pageUtils.url({ id, params }),
    navigate: (params, options) => pageUtils.navigate({ id, params }, options)
  };
}
